import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SimIconComponent } from '@simOn/ui/sim-icon';
import { EllipsisTooltipDirective } from '@simOn/ui/sim-tooltip';

@Component({
  selector: 'sim-recurrence-badge',
  imports: [SimIconComponent, EllipsisTooltipDirective],
  templateUrl: './recurrence-badge.component.html',
  styleUrl: './recurrence-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecurrenceBadgeComponent {
  readonly label = input.required<string>();
  readonly recurring = input<boolean>(false);

  protected readonly iconColor = computed(() =>
    this.recurring() ? 'var(--ui-primary-default, #4670db)' : 'var(--text-icon)'
  );
}
